<template>
  <div class="training-intents">
    <main-layout>
      <v-window v-model="currentView">
        <v-window-item :value="'list'">
          <div style="position: relative; min-height: 100vh">
            <v-premium-plan-popup
              :showAll="false"
              marginTop="65"
              v-if="$store.getters.getPackage != 'premium' || isCoachlab"
            ></v-premium-plan-popup>
            <div class="container-fluid" style="padding: 25px 15px">
              <div class="row">
                <div class="col s12 m8">
                  <h5>{{ $t('Default Conversation') }}</h5>
                </div>
                <div class="col s12 m4 form-control">
                  <input type="text" :placeholder="$t('Search')" v-model="search" />
                </div>
              </div>
              <div>
                <v-btn
                  class="mr-0"
                  color="primary"
                  @click="changeActiveTab('text')"
                  :outline="activeTab !== 'text'"
                  :depressed="activeTab === 'text'"
                  >Text</v-btn
                >
                <v-btn
                  color="primary"
                  @click="changeActiveTab('image')"
                  :outline="activeTab !== 'image'"
                  :depressed="activeTab === 'image'"
                  >Image</v-btn
                >
              </div>
              <v-divider></v-divider>
              <div class="row mt-2">
                <v-layout>
                  <v-flex>
                    <date-filter v-model="selectedDate" @onSelected="changeDate"></date-filter>
                  </v-flex>
                  <v-flex>
                    <div v-if="activeTab == 'text'" class="text-xs-right">
                      <a
                        href="javascript:void(0)"
                        class="btn btn-floating btn-small btn-outline-red"
                        :class="{ active: view == 'tag' }"
                        @click="view = 'tag'"
                      >
                        <span class="fas fa-th"></span>
                      </a>
                      <a
                        href="javascript:void(0)"
                        class="btn btn-floating btn-small btn-outline-red"
                        :class="{ active: view == 'list' }"
                        @click="view = 'list'"
                      >
                        <span class="fas fa-bars"></span>
                      </a>

                      <v-btn
                        depressed
                        outline
                        color="primary"
                        :loading="loading"
                        :disabled="filterDefaultIntents.length == 0"
                        @click="onExportTraining"
                      >
                        <i class="fas fa-file-export"></i>
                        &nbsp;{{ $t('export') }}&nbsp;
                        <v-premium-lock :inline="true"></v-premium-lock>
                      </v-btn>
                    </div>
                  </v-flex>
                </v-layout>

                <div class="row" v-if="currentFilter == 'custom_date'" style="margin-bottom: 0">
                  <div class="col s12 m6">
                    <span class="dashboard_datepicker">
                      {{ $t('from') }}:
                      <datepicker
                        v-model="selectedDate.start"
                        style="margin-bottom: 10px"
                        @selected="onSelectedStartDate"
                      ></datepicker>
                    </span>
                  </div>
                  <div class="col s12 m6">
                    <span class="dashboard_datepicker" style="margin-bottom: 10px">
                      {{ $t('to') }}:
                      <datepicker
                        v-model="selectedDate.end"
                        style
                        @selected="onSelectedEndDate"
                      ></datepicker>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="firstloading">
              <scale-loader
                :color="$vuetify.theme.primary"
                height="35px"
                width="7px"
              ></scale-loader>
            </div>
            <template v-else>
              <div v-if="activeTab === 'text'">
                <template v-if="filterDefaultIntents.length > 0">
                  <div style="padding: 0 15px">
                    <div>
                      <div
                        style="
                          background: #eee;
                          padding: 15px 15px 0;
                          margin-bottom: 15px;
                          border-radius: 5px;
                        "
                      >
                        <div class="row" style="margin-bottom: 0">
                          <div class="col s12 m5">
                            <v-checkbox
                              color="primary"
                              v-model="allSelected"
                              :label="$t('Select All')"
                              style="margin-top: 0"
                            ></v-checkbox>
                          </div>
                          <div class="col s12 m7 text-xs-left text-sm-right">
                            <v-btn
                              href="javascript:void(0)"
                              outline
                              color="grey"
                              :loading="loading"
                              class="primaryButton"
                              @click="
                                $store.getters.getPackage == 'premium' && !isCoachlab
                                  ? ignoreAll()
                                  : false
                              "
                              :disabled="selectedQuestionData.length == 0"
                              style="margin-bottom: 5px"
                              >{{ $t('Delete') }}</v-btn
                            >
                            <v-btn
                              depressed
                              color="primary"
                              class="primaryButton"
                              href="javascript:void(0)"
                              @click="createNewAll"
                              :disabled="selectedQuestionData.length == 0"
                              style="margin-bottom: 5px"
                              >{{ $t('Create new') }}</v-btn
                            >
                            <v-btn
                              depressed
                              color="primary"
                              class="primaryButton"
                              href="javascript:void(0)"
                              :disabled="selectedQuestionData.length == 0"
                              style="margin-bottom: 5px"
                              @click="
                                currentDefaultIntents = selectedQuestionData
                                showModal = true
                              "
                              >{{ $t('Add existing') }}</v-btn
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>

                <div class="container-fluid" style="padding: 0 15px">
                  <div
                    id="training_container"
                    style="
                      max-height: 600px;
                      overflow-y: auto;
                      border: 1px solid #eee;
                      padding: 10px;
                      border-radius: 5px;
                    "
                  >
                    <div class="row" style="margin-bottom: 0">
                      <div class="col s12">
                        <template v-if="filterDefaultIntents.length > 0">
                          <div class="container-fluid">
                            <template v-if="view == 'tag'">
                              <ul class="tags">
                                <li
                                  class="tag"
                                  :class="{ active: intent.selected }"
                                  style="
                                    margin-right: 5px;
                                    margin-bottom: 5px;
                                    cursor: pointer;
                                    text-align: left;
                                  "
                                  v-for="(intent, index) in filterDefaultIntents"
                                  :key="'intent_' + intent.id + '_' + index"
                                  :title="intent.questiondata"
                                  @click="intent.selected = !intent.selected"
                                >
                                  <span
                                    :class="{
                                      'fas fa-check-circle': intent.selected,
                                      'far fa-circle': !intent.selected
                                    }"
                                  ></span>
                                  <div
                                    style="
                                      display: inline-block;
                                      vertical-align: middle;
                                      word-break: break-all;
                                    "
                                  >
                                    {{ intent.questiondata }}
                                  </div>
                                  <template v-if="intent.count > 1"
                                    >({{ intent.count }})</template
                                  >
                                </li>
                              </ul>
                            </template>
                            <template v-else>
                              <div>
                                <v-pagination
                                  v-model="pageNumber"
                                  :length="pageCount"
                                  @input="onClickPageinate"
                                  class="mb-2"
                                ></v-pagination>
                              </div>
                              <training-item
                                :loadingId="loadingId"
                                class="z-border-red"
                                style="padding: 10px 10px 0"
                                v-for="(intent, index) in filterDefaultIntents"
                                :key="'intent_' + intent.id + '_' + index"
                                v-model="filterDefaultIntents[index]"
                                @onAddExistingConversation="
                                  currentDefaultIntents = []
                                  currentDefaultIntents.push(intent.questiondata)
                                  showModal = true
                                "
                                @onSaveTrainingConversation="saveTrainingIntent"
                                :excludedIntentName="excludedIntentName"
                                @onIgnore="onIgnore(intent.questiondata)"
                              ></training-item>
                              <div class="text-xs-center">
                                <v-pagination
                                  v-model="pageNumber"
                                  :length="pageCount"
                                  @input="onClickPageinate"
                                  class="mb-2"
                                ></v-pagination>
                              </div>
                            </template>
                          </div>
                        </template>
                        <template v-else>
                          <div class="text-xs-center" style="margin: 35px 0">
                            <img
                              src="/static/img/assets/setting/conversation.png"
                              alt
                              style="width: 230px"
                            />
                            <h3>{{ $t('No conversation') }}</h3>
                            <!-- <p>test</p> -->
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <div v-if="loading">
                  <scale-loader
                    :color="$vuetify.theme.primary"
                    height="35px"
                    width="7px"
                  ></scale-loader>
                </div>
                <div v-else>
                  <div class="text-xs-right">
                    <v-pagination
                      :total-visible="6"
                      v-model="pageNumberImg"
                      @input="changePageImg"
                      :length="pagelengthImg"
                    ></v-pagination>
                  </div>
                  <div v-if="imageintent.length" class="px-3">
                    <div
                      style="
                        border: 1px solid darkgrey;
                        border-radius: 6px;
                        display: flex;
                        flex-wrap: wrap;
                      "
                      class="pa-4"
                    >
                      <div
                        v-for="(item, k) in imageintent"
                        :key="k"
                        class="mr-2"
                        style="border: 1px solid #fe433b; border-radius: 6px"
                      >
                        <span v-for="(img, index) in item.questiondata" :key="index">
                          <v-img
                            @click="showImg(img)"
                            style="display: inline-block; cursor: pointer"
                            width="70px"
                            contain
                            :ref="'img_' + index"
                            @error="errorHandler(index)"
                            :src="img"
                          ></v-img>
                        </span>
                      </div>
                    </div>
                  </div>
                  <template v-else>
                    <div class="text-xs-center" style="margin: 35px 0">
                      <img
                        src="/static/img/assets/setting/conversation.png"
                        alt
                        style="width: 230px"
                      />
                      <h3>{{ $t('No conversation') }}</h3>
                      <!-- <p>test</p> -->
                    </div>
                  </template>
                </div>
              </div>
            </template>
          </div>

          <modal-dialog v-if="showModal" @close="showModal = false" :isFixed="true">
            <div slot="header">
              <h5>{{ $t('Training') }}</h5>
              <div class="row" style="margin-bottom: 0">
                <div class="col s12">
                  <div class="form-control">
                    <input type="text" :placeholder="$t('Search')" v-model="searchIntent" />
                  </div>
                </div>
              </div>
              <div class="hr" style="margin: 0 -10px 0px"></div>
            </div>

            <div slot="body">
              <div class="row" style="margin-top: 10px; margin-bottom: 10px">
                <div class="col s12">
                  <ul class="training-data" style="margin: 0; padding: 0">
                    <li
                      class="item z-border-red"
                      v-for="(intent, index) in filterIntents"
                      :key="'intent_' + index"
                      @click="addTrainingToConversation(intent)"
                    >
                      {{ intent.intentname }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div
              slot="footer"
              class="row text-xs-center"
              style="border-top: 1px solid #eee; padding-top: 10px; margin-bottom: 0"
            >
              <a href="javascript:void(0);" class="btn btn-default" @click="showModal = false">{{
                $t('cancel')
              }}</a>
            </div>
          </modal-dialog>
        </v-window-item>
        <v-window-item :value="'create_new'">
          <div class="container">
            <div class="row">
              <div class="col s12">
                <manage-intent
                  :type="'add'"
                  v-model="newIntent"
                  @close="onClose"
                  @saveIntent="onSaveIntent"
                  :excludedIntentName="excludedIntentName"
                ></manage-intent>
              </div>
            </div>
          </div>
        </v-window-item>
      </v-window>
    </main-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import DateFilter from '@/components/view/dashboard/DateFilter.vue'
import ModalDialog from '@/components/elements/ModalDialog'
import TrainingItem from './TrainingItem'
import api from '@/api'

// import { clearInterval } from "timers";

import datepicker from 'vuejs-datepicker'
import moment from 'moment'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import ManageIntent from './intent-manage'
export default {
  data: function() {
    return {
      totalImg: 0,
      offsetImg: 0,
      limitImg: 10,
      pagetmpImg: 1,
      pageNumberImg: 1,
      total: 0,
      offset: 0,
      limit: 30,
      pagetmp: 1,
      pageNumber: 1,
      imageintent: [],
      activeTab: 'text',

      size: 100,
      loadingId: '',
      currentView: 'list',
      training_intents: [],
      loading: false,
      firstloading: true,
      intents: [],
      search: '',
      searchIntent: '',
      showModal: false,
      currentDefaultIntents: [],
      allSelected: false,
      selectedDate: {
        start: moment()
          .startOf('month')
          .toDate(),
        end: moment()
          .endOf('month')
          .toDate()
      },
      currentFilter: 'this_month',
      ignoreInterval: undefined,
      ignoreCount: 0,
      view: 'tag',
      newIntent: {
        intentname: '',
        q_type: 'text',
        a_type: 'json',
        q_val: '',
        a_val: '[[]]',
        context_in: '',
        context_out: '',
        quick_reply: ''
      },
      training_process_count: 0,
      loadingTraining: null,
      trainingCount: 0
    }
  },
  components: {
    ModalDialog,
    TrainingItem,
    datepicker,
    ScaleLoader,
    ManageIntent,
    DateFilter
  },
  mounted: function() {
    var vm = this
    if (vm.$store.getters.getPackage != 'premium' || vm.isCoachlab) {
      return false
    }
    if (vm.$route.query.datefrom) {
      vm.selectedDate.start = vm.$route.query.datefrom
    }
    if (vm.$route.query.dateto) {
      vm.selectedDate.end = vm.$route.query.dateto
    }
    if (vm.$route.query.datefrom || vm.$route.query.dateto) {
      vm.currentFilter = 'custom_date'
    }

    vm.firstloading = true
    vm.getIntent(function() {
      vm.getTrainingConversation().then(
        function() {
          vm.firstloading = false
        },
        function(err) {
          vm.firstloading = false
        }
      )
    })
  },
  computed: {
    pagelengthImg() {
      if (this.totalImg) {
        return Math.ceil(this.totalImg / 10)
      } else {
        return 1
      }
    },
    ...mapGetters({
      selectedBot: 'selectedBot',
      isCoachlab: 'isCoachlab'
    }),
    pagelength() {
      if (this.total) {
        return Math.ceil(this.total / this.limit)
      } else {
        return 1
      }
    },
    excludedIntentName: function() {
      var result = []
      var vm = this
      $.each(vm.intents, function(index, intent) {
        result.push(intent.intentname)
      })
      return result.join(',')
    },
    filterDefaultIntents: function() {
      var vm = this
      var sorted = vm.training_intents.sort(function(a, b) {
        var nameA = a.questiondata.toUpperCase()
        var nameB = b.questiondata.toUpperCase()
        if (nameA < nameB) {
          return -1
        }
        if (nameA > nameB) {
          return 1
        }

        // names must be equal
        return 0
      })
      var training = sorted.filter(intent => {
        var isFound = false
        if (intent.questiondata != null && intent.questiondata != '') {
          isFound =
            intent.questiondata.toLowerCase().includes(vm.search.toLowerCase()) &&
            intent.training != true
        }
        return isFound
      })
      vm.trainingCount = training.length
      const start = (this.pageNumber - 1) * this.size
      const end = start + this.size
      if (vm.view == 'list') {
        return training.slice(start, end)
      } else {
        return training
      }
    },
    pageCount: function() {
      let l = this.trainingCount
      let s = this.size
      return Math.ceil(l / s)
    },
    filterIntents: function() {
      var vm = this
      vm.intents.sort(function(a, b) {
        var nameA = a.intentname.toUpperCase() // ignore upper and lowercase
        var nameB = b.intentname.toUpperCase() // ignore upper and lowercase
        if (a.intentname[0] == '{' && a.intentname[a.intentname.length - 1] == '}') {
          return 1
        }
        if (b.intentname[0] == '{' && b.intentname[b.intentname.length - 1] == '}') {
          return -1
        }
        if (nameA < nameB) {
          return -1
        }
        if (nameA > nameB) {
          return 1
        }

        // names must be equal
        return 0
      })

      return vm.intents.filter(intent => {
        var isFound = intent.intentname.toLowerCase().includes(vm.searchIntent.toLowerCase())
        //  ||
        // intent.q_val.toLowerCase().includes(vm.searchIntent.toLowerCase()) ||
        // intent.a_val.toLowerCase().includes(vm.searchIntent.toLowerCase())
        return isFound
      })
    },
    selectedQuestionData: function() {
      var questions = []
      var vm = this
      if (vm.filterDefaultIntents) {
        vm.filterDefaultIntents.map(function(el) {
          if (el.selected) {
            questions.push(el.questiondata)
          }
        })
      }
      return questions
    }
  },
  methods: {
    changePageImg(val) {
      var vm = this
      if (this.pagetmpImg == val) {
        //dont do shit
      } else {
        this.pagetmpImg = val
        vm.offsetImg = vm.pageNumberImg * this.limitImg - this.limitImg
        if (vm.pageNumberImg != 1) {
          vm.offsetImg + 1
        }
        this.getImageChatlogs()
      }
    },
    showImg(img) {
      window.open(img, '_blank')
      // window.location.assign(img)
    },
    errorHandler(i) {
      this.$refs['img_' + i][0].src = require('./errorimage.png')
    },
    changeActiveTab(val) {
      this.activeTab = val
      if (val == 'image') {
        this.getImageChatlogs()
      }
    },
    getImageChatlogs() {
      var data = {
        pageid: this.selectedBot.pageid,
        datefrom: moment(this.selectedDate.start).format('YYYY-MM-DD'),
        dateto: moment(this.selectedDate.end).format('YYYY-MM-DD'),
        limit: this.limitImg,
        offset: this.offsetImg
      }
      this.loading = true
      api.getImageChatlogs(data, (err, response) => {
        this.loading = false
        this.imageintent = response.data.map(el => {
          return { ...el, questiondata: el.questiondata ? el.questiondata.split(';;') : [] }
        })
        this.totalImg = response.total ? parseInt(response.total) : 0
      })
    },
    onClickPageinate(pageNum) {
      this.pageNumber = pageNum
      this.$nextTick(() => {
        $('html, body').animate({
          scrollTop: 0
        })
        $('#training_container').animate({
          scrollTop: 0
        })
      })
    },
    onSaveIntent: function() {
      var vm = this
      vm.loading = true
      vm.currentView = 'list'
      if (vm.selectedQuestionData) {
        vm.training_process_count = vm.selectedQuestionData.length
        vm.selectedQuestionData.map(function(el) {
          var data = {
            intentname: vm.newIntent.intentname,
            questiondata: el
          }
          vm.saveTrainingIntent(data).then(function() {
            vm.training_process_count--
          })
        })
      }

      vm.loadingTraining = setInterval(function() {
        if (vm.training_process_count === 0) {
          if (vm.loadingTraining) {
            clearInterval(vm.loadingTraining)
            vm.getIntent(function() {
              vm.getTrainingConversation().then(
                function() {
                  vm.loading = false
                },
                function(err) {
                  vm.loading = false
                }
              )
            })
          }
        }
      }, 1000)
    },
    onClose: function() {
      this.currentView = 'list'
    },
    onSelectedStartDate: function(value) {
      var vm = this
      vm.currentFilter = 'custom_date'
      if (moment(this.selectedDate.end).isBefore(value)) {
        this.selectedDate.end = value
      }
      this.selectedDate.start = value
      vm.loading = true
      this.getTrainingConversation().then(
        function() {
          vm.pageNumber = 1
          vm.loading = false
        },
        function(err) {
          vm.loading = false
        }
      )
    },
    createNewAll: function() {
      var vm = this

      vm.newIntent = {
        intentname: '',
        q_type: 'text',
        a_type: 'json',
        q_val: vm.selectedQuestionData.join(','),
        a_val: '[[]]',
        context_in: '',
        context_out: '',
        quick_reply: ''
      }
      vm.currentView = 'create_new'
    },
    onSelectedEndDate: function(value) {
      var vm = this
      vm.currentFilter = 'custom_date'
      if (moment(value).isBefore(this.selectedDate.start)) {
        this.selectedDate.start = value
      }
      this.selectedDate.end = value
      vm.loading = true
      this.getTrainingConversation().then(
        function() {
          vm.pageNumber = 1
          vm.loading = false
        },
        function(err) {
          vm.loading = false
        }
      )
    },
    onSelectedDate: function(value) {
      var vm = this
      vm.loading = true
      this.getTrainingConversation().then(
        function() {
          vm.pageNumber = 1
          vm.loading = false
        },
        function(err) {
          vm.loading = false
        }
      )
    },
    changeDate: function(value) {
      if (this.activeTab == 'text') {
        this.onSelectedDate()
      } else {
        this.getImageChatlogs()
      }
    },
    getTrainingConversation: function() {
      return new Promise((resolve, reject) => {
        var vm = this
        var data = {
          pageid: vm.selectedBot.pageid,
          intentname: '{default}',
          datefrom: moment(this.selectedDate.start).format('YYYY-MM-DD'),
          dateto: moment(this.selectedDate.end).format('YYYY-MM-DD')
        }
        api.getTraningConversation(data, function(error, response) {
          if (error) {
            reject(error)
          }
          var training_intents = []
          $.each(response.data, function(index, intent) {
            var tmp_intent = intent
            tmp_intent.selected = false

            var isFound = false

            $.each(training_intents, function(index, value) {
              if (value.id != tmp_intent.id && tmp_intent.questiondata == value.questiondata) {
                training_intents[index].count += 1
              }

              if (
                value.id != tmp_intent.id &&
                tmp_intent.questiondata == value.questiondata &&
                tmp_intent.training != true &&
                value.training != true
              ) {
                isFound = true
                // vm.updateTrainingConversation(value.id, function(index) {});
                return false
              }
            })

            if (!isFound) {
              tmp_intent.count = 1
              training_intents.push(tmp_intent)
            }
          })

          vm.training_intents = training_intents

          resolve()
        })
      })
    },
    getIntent: function(callback) {
      let vm = this
      let auth = null
      let data = {
        pageid: vm.selectedBot.pageid
      }
      vm.intents = []
      api.getIntent(data, function(error, response) {
        if (error) {
          console.error(error)
          return
        }
        if (response.data) {
          var isFoundDefault = false
          $.each(response.data, function(index, val) {
            var intent = val
            intent.isShow = false
            intent.ableToDelete = true
            if (intent.intentname == '{default}') {
              intent.ableToDelete = false
              isFoundDefault = true
              vm.default_intent = intent
            } else {
              vm.intents.push(intent)
            }
          })
        }
        callback()
      })
    },
    addTrainingToConversation: function(intent) {
      let vm = this
      if (
        !vm.currentDefaultIntents ||
        (vm.currentDefaultIntents && vm.currentDefaultIntents.length == 0)
      ) {
        return false
      }

      let data = {
        pageid: vm.selectedBot.pageid,
        intentname: intent.intentname,
        q_type: intent.q_type,
        q_val: intent.q_val + ',' + vm.currentDefaultIntents.join(','),
        a_type: intent.a_type,
        a_val: intent.a_val,
        context_in: intent.context_in,
        context_out: intent.context_out,
        quick_reply: intent.quick_reply
      }

      if (data.a_type == 'message' || data.a_type == 'generic') {
        data.a_val = '{welcome_message}'
      } else if (data.a_type == 'template') {
        data.a_val = JSON.stringify(vm.generics)
      } else if (data.a_type == 'viewsummary') {
        data.a_val = '{viewsummary}'
      } else if (data.a_type == 'none') {
        data.a_val = ''
      }

      if (vm.isReplyComment) {
        data.a_val = vm.replyComment
      }

      vm.$swal
        .fire({
          title: vm.$t('Do you want to add {question} to {intent}?', {
            question:
              vm.currentDefaultIntents[0] + (vm.currentDefaultIntents.length > 1 ? '...' : ''),
            intent: intent.intentname.replace(/\<|\>/g, '')
          }),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            vm.loading = true
            vm.showModal = false
            data['id'] = intent.id
            api.editIntent(data, function(error, response) {
              if (error) {
                console.error(error)
                vm.loading = false
                return
              }

              if (vm.currentDefaultIntents) {
                console.log(vm.currentDefaultIntents[0])
                vm.loadingId = vm.currentDefaultIntents[0]
                vm.training_process_count = vm.currentDefaultIntents.length
                vm.currentDefaultIntents.map(function(el) {
                  var data = {
                    intentname: intent.intentname,
                    questiondata: el
                  }
                  vm.saveTrainingIntent(data).then(function() {
                    vm.training_process_count--
                  })
                })
              }

              vm.loadingTraining = setInterval(function() {
                if (vm.training_process_count === 0) {
                  if (vm.loadingTraining) {
                    clearInterval(vm.loadingTraining)
                    vm.currentDefaultIntents = []
                    vm.getIntent(function() {
                      vm.getTrainingConversation().then(
                        function() {
                          vm.loading = false
                        },
                        function(err) {
                          vm.loading = false
                        }
                      )
                    })
                  }
                }
              }, 1000)
            })
          }
        })
    },
    updateTrainingConversation: function(data, callback) {
      var vm = this
      api.updateTrainingConversation(data, function(error, response) {
        if (error) {
          console.error(error)
          callback()
          return
        }
        if (vm.training_intents.length <= 0) {
          callback(null)
          return false
        }
        $.each(vm.training_intents, function(index, intent) {
          if (intent.questiondata == data.questiondata) {
            callback(index)
            return false
          }
        })
      })
    },
    saveTrainingIntent: function(payload) {
      var vm = this
      return new Promise((resolve, reject) => {
        var data = {
          pageid: vm.selectedBot.pageid,
          questiondata: payload.questiondata,
          newintent: payload.intentname
        }
        vm.updateTrainingConversation(data, function(index) {
          resolve()
        })
      })
    },
    ignoreAll: function() {
      var vm = this
      vm.$swal
        .fire({
          title: vm.$t('Do you want to ignore selected?'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            vm.loading = true
            vm.ignoreCount = vm.training_intents.length

            $.each(vm.training_intents, function(index, intent) {
              if (intent.selected) {
                vm.ignoreTrainingIntent(intent.questiondata, function() {
                  vm.ignoreCount--
                })
              } else {
                vm.ignoreCount--
              }
            })
            vm.ignoreInterval = setInterval(() => {
              if (vm.ignoreCount == 0) {
                clearInterval(vm.ignoreInterval)
                vm.getIntent(function() {
                  vm.getTrainingConversation().then(
                    function() {
                      vm.loading = false
                    },
                    function(err) {
                      vm.loading = false
                    }
                  )
                })
              }
            }, 1000)
          }
        })
    },
    onIgnore: function(id) {
      var vm = this
      vm.$swal
        .fire({
          title: vm.$t('Do you want to ignore selected?'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            vm.loading = true
            vm.loadingId = id
            vm.ignoreTrainingIntent(id, function() {
              vm.getIntent(function() {
                vm.getTrainingConversation().then(
                  function() {
                    vm.loading = false
                  },
                  function(err) {
                    vm.loading = false
                  }
                )
              })
            })
          }
        })
    },
    ignoreTrainingIntent: function(questiondata, callback) {
      var vm = this
      // vm.$store.dispatch("loading");
      var data = {
        pageid: vm.selectedBot.pageid,
        questiondata: questiondata,
        newintent: ''
      }
      vm.updateTrainingConversation(data, function(index) {
        callback()
      })
    },
    selectAll: function() {
      var vm = this
      vm.intentId = []
      $.each(vm.filterDefaultIntents, function(index, intent) {
        $.each(vm.training_intents, function(dindex, dintent) {
          if (intent.id == dintent.id) {
            vm.training_intents[dindex].selected = vm.allSelected
            return false
          }
        })
      })
    },
    select: function() {
      this.allSelected = false
    },
    onExportTraining: function() {
      let vm = this
      let csvContent = ''
      if (vm.loading) {
        return false
      }

      csvContent += 'Message'

      csvContent += '\r\n'

      $.each(vm.filterDefaultIntents, function(index, val) {
        let row = ''
        const question = (val.questiondata ? val.questiondata : '').replace(/(=|\+)(cmd\|)/g, '')
        const count = val.count > 0 ? '(' + val.count + ')' : ''

        row += `"${question.replace(/\r?\n|\r/g, ' / ')}${count}",`
        csvContent += row + '\r\n'
      })

      vm.exportCsv(csvContent, 'training')
    }
  },
  watch: {
    allSelected: function(newVal, oldVal) {
      var vm = this
      vm.selectAll()
    },
    search: function(newVal, oldVal) {
      if (newVal != oldVal) {
        this.pageNumber = 1
      }
    }
  }
}
</script>

<style scoped>
.primaryButton {
  margin-left: 0;
  margin-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/view/intent/Training.vue